/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-04-26 17:23:34
 * @LastEditors: 南岸有归
 * @Description: 
 * @FilePath: \cloud_frontend\src\views\resource\Firmware\TableConfig.js
 * @
 */
import i18n from "../../../common/lang";
export const Columns=[
    {LabelName:i18n.t('lang.firmware.multitasking'),key:0,ColumnsKey:'tName',seek:'tName',placeholder:i18n.t('lang.firmware.search1'), sort: 'custom'},
    {LabelName:i18n.t('lang.firmware.VI_Task'),key:1,ColumnsKey:'tDescription',seek:'tDescription',placeholder:i18n.t('lang.firmware.search2'), sort: 'custom'},
    {LabelName:i18n.t('lang.upgrade.completion'),key:2,align:'center',ColumnsKey:'progress',seek:'progress',placeholder:i18n.t('lang.upgrade.search3'),slot:true, sort: 'custom'},
    {LabelName:i18n.t('lang.firmware.createFile'),key:3,ColumnsKey:'cfName',seek:'cfName',placeholder:i18n.t('lang.firmware.search4'),Fun:'GetCfName', sort: 'custom'},
    {LabelName:i18n.t('lang.firmware.timerfunction'),key:4,ColumnsKey:'tUpdate',seek:'tUpdate',placeholder:i18n.t('lang.firmware.search5'), sort: 'custom'}
]

export const ColuumnsButton=[
    {key:0,type:'danger',icon:'el-icon-delete',Fun:'delLevelUp',Delete:true,Authority:125}
]

export const Expands=[
    {LabelName:'序号',key:0,align:'center',ExpandsKey:'Index',slot:true},
    {LabelName:i18n.t('lang.firmware.equipment'),key:1,align:'center',isChildCustom: true, ExpandsKey:'deviceSn',Fun:'GetFirmwareSn'},
    {LabelName:i18n.t('lang.firmware.AsyncOperationStatus'),key:2,align:'center',ExpandsKey:'stSign',Tag:true,Fun:'GetFirmwareChildStatus'}
]
export const ExpandsButton=[
    {key:0,type:'danger',icon:'el-icon-delete',Delete:true,Fun:'delSonLevelUp',Authority:126}
]
